import React from 'react';

export default function Input({ label, error, className = '', ...props }) {
  return (
    <div className={`flex flex-col space-y-1.5 ${className}`}>
      {label && <label className="text-sm font-semibold text-gray-700">{label}</label>}
      <input 
        className={`px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-shadow ${
          error ? 'border-red-500 ring-1 ring-red-500' : 'border-gray-300'
        }`}
        {...props} 
      />
      {error && <span className="text-xs text-red-500 font-medium">{error}</span>}
    </div>
  );
}